import React, { useEffect, useState, useRef } from 'react';
import ReactDOM from "react-dom";

const TOOLTIP_BG_COLOR = "#FCFCFF";
const TEXT_COLOR = "#252528";

const BubbleBox = (props) => {
  const { theme, text, id, targetRef, onClose } = props;
  const toastRef = useRef(null);
  const [position, setPosition] = useState({ top: 0, left: 0 });
  let tooltipBgColor = TOOLTIP_BG_COLOR;
  let textColor = TEXT_COLOR;
  let opacity = "100%";
  
  if (!!theme) {
    tooltipBgColor = theme.palette.background.tooltip;
    textColor = theme.palette.text.primary;
    if (theme.palette.type === "dark") {
      opacity = "90%"
    }
  }

  const updatePosition = () => {
    if (targetRef.current && toastRef.current) {
      const buttonRect = targetRef.current.getBoundingClientRect();
      const bubbleRect = toastRef.current.getBoundingClientRect();

      const buttonCenterX = buttonRect.left + buttonRect.width / 2;
      const left = !!id ? buttonCenterX - bubbleRect.width : buttonCenterX;
      const top = buttonRect.bottom;
      setPosition({ top, left });
    }
  };

  useEffect(() => {
    updatePosition();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    const timeout = setTimeout(() => {
      onClose?.();
    }, 2000);
    return () => clearTimeout(timeout);
  }, [onClose]);

  useEffect(() => {
    const handleClickOutside = (e) => {
      onClose?.();
    };
    document.addEventListener("mousedown", handleClickOutside);
    document.addEventListener("touchstart", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
      document.removeEventListener("touchstart", handleClickOutside);
    };
  }, [onClose]);

  return ReactDOM.createPortal(
    <div
      ref={toastRef}
      id={`bubble-${id}`}
      style={{
        position: 'fixed',
        top: position.top,
        left: position.left,
        backgroundColor: tooltipBgColor,
        padding: '10px',
        borderRadius: '22px',
        whiteSpace: 'nowrap',
        marginTop: '6px',
        marginBottom: '6px',
        boxShadow: '0 2px 8px 0 rgba(0,0,0,0.15)',
        fontFamily: 'sec-400',
        fontSize: '16px',
        color: textColor,
        opacity: opacity,
        userSelect: 'none'
      }}
    >
      {text}
    </div>,
    document.body
  )
}

export default BubbleBox;